import { ReactElement, useCallback } from 'react';
import { Trans } from 'react-i18next';

import {
   Link,
   LinkSize,
   Notification,
   NotificationSize,
   NotificationType,
   useHistoryPushWithBackAction,
} from '@dreryk/react-components';
import { Translate } from '@dreryk/react-common';

import { protectFeature } from '~libs.shared.system';
import { getHealthcareProviderDataPath } from '~legacy.p1';

import { dischargeSummaryTranslationKeys } from '../../../../translations';

export const MedicalDepartmentFieldMissingDepartmentNotification = (): ReactElement => {
   const push = useHistoryPushWithBackAction(true);
   const goToHealthcareProviderSettings = useCallback(
      (): void =>
         push(getHealthcareProviderDataPath('HEALTHCARE_ORGANIZATION'), {
            label: dischargeSummaryTranslationKeys.goBackToVisit,
         }),
      [push]
   );
   return (
      <Notification
         testId={'missingDepartment'}
         type={NotificationType.INFO}
         size={NotificationSize.SMALLER}
         label={
            <span>
               <Translate>{dischargeSummaryTranslationKeys.missingDepartmentCode}</Translate>{' '}
               {protectFeature(
                  'updatingProviderData',
                  <Trans
                     i18nKey={dischargeSummaryTranslationKeys.fillDepartmentCodeIn}
                     components={{
                        healthcareOrganizationSettingsLink: (
                           <Link
                              testId={'goToHealthcareOrganizationSettings'}
                              label={dischargeSummaryTranslationKeys.healthcareOrganizationData}
                              onClick={goToHealthcareProviderSettings}
                              block={false}
                              size={LinkSize.SMALL}
                           />
                        ),
                     }}
                  />,
                  <Translate>{dischargeSummaryTranslationKeys.contactAdministratorForDepartmentCode}</Translate>
               )}
            </span>
         }
      />
   );
};
